<div class="correctionContainer dropShadow" [ngStyle]="getBorder()" [@correctionAnimation]="isVisible ? 'visible' : 'hidden'">
  <div class="contentContainer">
    <div class="titleContainer">
      @if (!isCorrectionWrong()) {
        <ng-lottie [options]="goodAnswerOptions" (animationCreated)="gaAnimationCreated($event)" />
      }
      @if (isCorrectionWrong()) {
        <ng-lottie class="badAnswer" [options]="badAnswerOptions" (animationCreated)="baAnimationCreated($event)" />
      }
      <div class="title">
        @if (isCorrectionWrong()) {
          <span>{{ 'common.answers.bad' | translate }}</span>
        }
        @if (!isCorrectionWrong()) {
          <span>{{ 'common.answers.good' | translate }}</span>
        }
      </div>
    </div>
    <div class="answersContainer">
      @for (correct of getAnswersToDisplay(); track correct) {
        <div class="answerContainer">
          @if (correct.item) {
            <div class="answer">
              {{ correct.item }}
            </div>
          }
          <div class="explanation">
            @if (shouldDisplayUniqueAnswerType() && isCorrectionWrong()) {
              <span class="answerType">{{ 'common.answers.badPoint' | translate }}</span>
            }
            @if (shouldDisplayUniqueAnswerType() && !isCorrectionWrong()) {
              <span class="answerType">{{ 'common.answers.goodPoint' | translate }}</span>
            }
            <span class="content">{{ correct.details }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</div>
